import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CashClosureAccountRequest, CashClosureRequest } from '../models/cash-closure.model';

@Injectable({
	providedIn: 'root'
})
export class CashClosureService {
	private URL = environment.api + "api/erp/cashClosure";
	constructor(
		private http: HttpClient
	) { }

	createCashClosure(request: CashClosureRequest) {
		return this.http.post(this.URL, request);
	}

	createAccountReceivable(accounts: CashClosureAccountRequest[]) {
		return this.http.post(this.URL + "/accountReceivable", accounts);
	}

	deleteAccountReceivable(idClashClosure: any) {
		return this.http.delete(this.URL + "/accountReceivable/" + idClashClosure);
	}

	getHistoryCashClosure(startDate, endDate) {
		return this.http.get(this.URL, {
			params: {
				startDate: startDate,
				endDate: endDate
			}
		});
	}

	deleteCashClosure(id: number, notify: boolean) {
		return this.http.post(`${this.URL}/${id}?notify=${notify}`, null);
	}

	getHistoryCashClosureOfWarehouse(startDate, endDate, warehouseId) {
		return this.http.get(this.URL + `/warehouse/${warehouseId}`, {
			params: {
				startDate: startDate,
				endDate: endDate
			}
		});
	}

	getHistoryCashClosureTransfers(startDate, endDate, warehouseId) {
		return this.http.get(this.URL + `/bankTransfer/${warehouseId}`, {
			params: {
				startDate: startDate,
				endDate: endDate
			}
		});
	}

	rollbackHistoryCashClosureTransfer(transferId: number) {
		return this.http.post(this.URL + `/bankTransfer/${transferId}`, null);
	}

	getImagesByDay(dayId) {
		return this.http.get(this.URL + `/cashClosure/${dayId}`);
	}

	getAccounts(startDate, endDate, page = 0, size = 5){
		return this.http.get(this.URL + "/accounts", {
			params: {
				startDate: startDate,
				endDate: endDate,
				page: page,
				size: size
			}
		});
	}

	getHistoryCashClosureDestination(startDate, endDate) {
		return this.http.get(this.URL + "/all-warehouse-destination", {
			params: {
				startDate: startDate,
				endDate: endDate
			}
		});
	}

	getHistoryCashClosureOfWarehouseDestination(startDate, endDate, warehouseId) {
		return this.http.get(this.URL + `/warehouse-destination/${warehouseId}`, {
			params: {
				startDate: startDate,
				endDate: endDate
			}
		});
	}

	getProductsLiquidationIntervalDate(warehouseDestinationId) {
		return this.http.get(this.URL + `/warehouse-destination-products/${warehouseDestinationId}`);
	}

	getInvoicesLiquidationIntervalDate(warehouseDestinationId,productId) {
		return this.http.get(this.URL + `/warehouse-destination-invoices/${warehouseDestinationId}/${productId}`);
	}

	getDetailInvoicesLiquidationIntervalDate(warehouseDestinationId,productId) {
		return this.http.get(this.URL + `/warehouse-destination-detail/${warehouseDestinationId}/${productId}`);
	}

	getExpensesDetailIntervalDate(warehouseDestinationId) {
		return this.http.get(this.URL + `/warehouse-destination-expenses/${warehouseDestinationId}`);
	}

	getRecoveryDetailIntervalDate(warehouseDestinationId) {
		return this.http.get(this.URL + `/warehouse-destination-recovery-detail/${warehouseDestinationId}`);
	}

	getCreditDetailIntervalDate(warehouseDestinationId) {
		return this.http.get(this.URL + `/warehouse-destination-credit-detail/${warehouseDestinationId}`);
	}

	getBankTransferByType(warehouseDestinationId, type) {
		return this.http.get(this.URL + `/warehouse-destination-bank-transfer/${warehouseDestinationId}/${type}`);
	}

	deleteBankTransferByType(bankAccountTransferId: any) {
		return this.http.delete(this.URL + `/warehouse-destination-bank-transfer/${bankAccountTransferId}`);
	}
}